import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
    :root {
        --background: transparent;
        --font-mono: monospace;
        //--font-mono: "Anonymous Pro", monospace;
        //--font-mono: "DM Mono", monospace;
        //--font-mono: "Fira Mono", monospace;
        //--font-mono: "IBM Plex Mono", monospace;
        //--font-mono: "JetBrains Mono", monospace;
        //--font-mono: "Oxygen Mono", monospace;
        //--font-mono: "PT Mono", monospace;
        //--font-mono: "Roboto Mono", monospace;
        //--font-mono: "Source Code Pro", monospace;
        //--font-mono: "Teko", monospace;
        //--font-mono: "Ubuntu Mono", monospace;
        //--font-mono: "Ubuntu Sans Mono", monospace;

        font-family: sans-serif;
        scroll-behavior: smooth;
    }

    body {
        background: var(--background);
        margin: 0;
    }
`;
